module.exports = __webpack_public_path__ + "img/RORBPJR40015.3404fd1a.png";